import { ID, overdueSectionID, SortingMode, UpdateTask } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';

export const useUpcomingListOnReorder = () => {
  const updateSettings = useUpdateUserSettings();
  const { mutate: updateTasks } = useUpdateTasksMutation();

  return useCallback(
    (
      updatedSections: { id: ID; taskSorting: ID[] }[],
      updatedTasks: UpdateTask[],
    ) => {
      const todoSorting = updatedSections.reduce<Record<ID, ID[]>>(
        (acc, section) => {
          if (section.id === overdueSectionID) {
            return acc;
          }
          acc[section.id] = section.taskSorting;
          return acc;
        },
        {},
      );

      updateSettings({
        todoSortingMode: SortingMode.Custom,
        todoSorting,
      });

      if (updatedTasks.length) {
        updateTasks(updatedTasks);
      }
    },
    [updateSettings, updateTasks],
  );
};
